import { TranslationPreloaderService } from './translation-preloader.service';

export function preloadLang(translationPreloaderService: TranslationPreloaderService) {
  return () => translationPreloaderService.init();
}
